export default __webpack_public_path__ + "static/media/Nosifer-Regular.09ac1852.ttf";